// src/mocks/toggles.js

/**
 * Determina si MSW debe activarse
 * Requiere: NODE_ENV === 'development' Y query param ?msw=on
 */
export function mswEnabled() {
  if (typeof window === 'undefined') return false

  const url = new URL(window.location.href)
  const byQuery = url.searchParams.get('msw') === 'on'
  const byEnv = process.env.NODE_ENV === 'development'

  return byQuery && byEnv
}

/**
 * Forzar error via localStorage
 * Uso: setForcedError('500') -> localStorage.setItem('msw:error', '500')
 */
export function setForcedError(status) {
  if (!status) {
    localStorage.removeItem('msw:error')
  } else {
    localStorage.setItem('msw:error', status)
  }
}

